module.exports = __webpack_public_path__ + "static/media/Screen Shot 2021-10-12 at 9.47.19 PM.fe011735.png";